import client from '@/api/client';

export const BANK_VALIDATIONS_START = 'bankValidations/token/START';
export const BANK_VALIDATIONS_SUCCESS = 'bankValidations/token/SUCCESS';
export const BANK_VALIDATIONS_FAILURE = 'bankValidations/token/FAILURE';

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    result: {},
  },
  actions: {
    find({ commit }, payload) {
      commit(BANK_VALIDATIONS_START);

      return new Promise((resolve, reject) => {
        client
          .get('/customers/bank_validations', {
            params: {
              ...payload,
            },
          })
          .then((response) => {
            commit(BANK_VALIDATIONS_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(BANK_VALIDATIONS_FAILURE, error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    [BANK_VALIDATIONS_START](state) {
      state.error = null;
      state.loading = true;
      state.result = {};
    },
    [BANK_VALIDATIONS_SUCCESS](state, response) {
      const result = response.data;

      state.error = null;
      state.loading = false;
      state.result = result;
    },
    [BANK_VALIDATIONS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.error = details;
      state.loading = false;
      state.result = {};
    },
  },
};
